// src/components/eventos/components/operacional/EstadoVazio.js
import React from 'react';

const EstadoVazio = () => (
    <div style={{ textAlign: 'center', padding: '64px 24px', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '16px', fontFamily: "'Inter', -apple-system, sans-serif", boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
        <div style={{ width: '64px', height: '64px', borderRadius: '16px', background: '#f8fafc', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
        </div>
        <p style={{ margin: '0 0 8px', fontSize: '18px', fontWeight: 700, color: '#64748b' }}>Nenhum evento ativo ou agendado</p>
        <p style={{ margin: 0, fontSize: '14px', color: '#94a3b8' }}>Aguarde o agendamento de um evento para visualizar o programa</p>
    </div>
);

export default EstadoVazio;
